import { ScreeningPolygonResult } from './screening-polygon-result';
import { ScreeningLocationResultItem } from './screening-polygon-detail.view';
import { ScreeningFlag } from '../enums';
import { ScreeningLog } from './screening-log';

export class ScreeningHistoryItem {
    public locationId: string;
    public screeningId: string;
    public createdAt: Date;
    public hasV1Polygon: boolean;
    public hasV2Polygon: boolean;
    public v1PolygonResult: ScreeningPolygonResult;
    public v2PolygonResult: ScreeningPolygonResult;
    public v1Screenings: Array<ScreeningLocationResultItem>;
    public v2Screenings: Array<ScreeningLocationResultItem>;
    public totalFlags: ScreeningFlag;
    public screeningLog: ScreeningLog;
    public formattedDate: string;

    public constructor(init: Partial<ScreeningHistoryItem>) {
        Object.assign(this, init);
    }
}
